import { mappingRoutes } from "src/app/core/mappingRoutes";

export const DASHBOARD_ROUTES: any[] = [
  {
    path: mappingRoutes.dashboard,
    name: "Accueil",
    title: "Tableau de bord",
    icon: "windows",
    prefix: "home",
    class: "",
    children: [],
  },

  // Institutions promu en menu de premier niveau (sortis du sous-menu
  // Référentiel) : c'est l'entrée racine de la hiérarchie tenant —
  // utilisé par le SystemAdmin pour drill-in vers une institution puis
  // démarrer une impersonation. Réservé SYSTEM (chantier R Sprint 2).
  {
    path: mappingRoutes.referential.institutions.listing,
    name: "Institutions",
    title: "Institutions",
    icon: "global",
    prefix: "referential/institutions",
    class: "",
    children: [],
    requiredSystemRoles: ["SYSTEM"],
  },

  // Administrateurs système — CRUD des comptes SYSTEM. Réservé SYSTEM.
  {
    path: "/administration/system/admins/list",
    name: "Administrateurs système",
    title: "Administrateurs système",
    icon: "safety-certificate",
    prefix: "system/admins",
    class: "",
    children: [],
    requiredSystemRoles: ["SYSTEM"],
  },

  {
    path: "#",
    prefix: "complaints",
    title: "Gestion des plaintes",
    name: "Plaintes",
    icon: "alert",
    class: "",
    children: [
      {
        path: mappingRoutes.plaintes.listing,
        name: "Liste ",
        class: "",
      },
      {
        path: mappingRoutes.plaintes.create.home,
        name: "Ajouter",
        class: "",
      },
    ],
  },

  {
    path: "#",
    prefix: "security_habilitation",
    title: "Sécurité_habilitations",
    name: "Sécurité & habilitations",
    icon: "key",
    class: "",
    requiredSystemRoles: ["SYSTEM"],
    children: [
      {
        path: mappingRoutes.profiles.listing,
        name: "Profils",
        class: "",
      },
      {
        path: mappingRoutes.permissions.listing,
        name: "Permissions",
        class: "",
      },
    ],
  },

  {
    path: "#",
    prefix: "configurations",
    title: "Configurations",
    name: "Référentiel",
    icon: "appstore",
    class: "",
    requiredSystemRoles: ["SYSTEM"],
    children: [
      {
        path: mappingRoutes.referential.home,
        name: "Accueil",
        class: "",
      },
      {
        path: mappingRoutes.referential.complaintType.listing,
        name: "Types de plainte",
        class: "",
      },

      {
        path: mappingRoutes.referential.categoriesPlaintes.listing,
        name: "Catégories de plainte ",
        class: "",
      },
      {
        path: mappingRoutes.referential.sensibilityPlaintes.listing,
        name: "Sensibilités de plainte",
        class: "",
      },

      {
        path: mappingRoutes.referential.locations.cities.list,
        name: "Villes",
        class: "",
      },
    ],
  },

  {
    path: "#",
    prefix: "FAQS",
    title: "FAQS",
    name: "Forums ",
    icon: "question-circle",
    class: "",
    children: [
      {
        path: mappingRoutes.categorieFasq.listing,
        name: "Catégories",
        class: "",
      },
      {
        path: mappingRoutes.questionFaq.listing,
        name: "Questions",
        class: "",
      },
    ],
  },

  // Providers techniques (SMTP/SMS/Stockage) — réservé SYSTEM. Placé en
  // dernier intentionnellement : c'est de l'admin technique de bas niveau,
  // pas un point d'entrée quotidien.
  {
    path: mappingRoutes.system.providers.home,
    name: "Paramètres techniques",
    title: "Email · SMS · Stockage",
    icon: "api",
    // prefix doit être un fragment d'URL UNIQUE à cette section. Mettre
    // "" rend `router.url.includes(prefix)` toujours vrai → le titre
    // de la navbar reste collé sur toute navigation. Cf. getTitleMenu()
    // dans layouts/navbar/navbar.component.ts.
    prefix: "system/providers",
    class: "",
    children: [],
    requiredSystemRoles: ["SYSTEM"],
  },
];

export const AGENT_DASHBOARD_ROUTES: any[] = [
  {
    path: mappingRoutes.dashboard,
    name: "Accueil",
    title: "Tableau de bord",
    icon: "windows",
    prefix: "home",
    class: "",
    children: [],
  },

  {
    path: "#",
    prefix: "complaints",
    title: "Gestion des plaintes",
    name: "Plaintes",
    icon: "alert",
    class: "",
    children: [
      {
        path: mappingRoutes.plaintes.listing,
        name: "Liste ",
        class: "",
      },
      {
        path: mappingRoutes.plaintes.create.home,
        name: "Ajouter",
        class: "",
      },
    ],
  },

  {
    path: "#",
    prefix: "staffs",
    title: "Gestion du staff",
    name: "Staffs",
    icon: "user",
    class: "",
    children: [
      {
        path: mappingRoutes.staffs.listing,
        name: "Liste",
        class: "",
      },
    ],
  },

  {
    path: "#",
    prefix: "configurations",
    title: "Configurations",
    name: "Référentiel",
    icon: "appstore",
    class: "",
    children: [
      {
        path: mappingRoutes.referential.home,
        name: "Accueil",
        class: "",
      },
      {
        path: mappingRoutes.referential.complaintType.listing,
        name: "Types de plainte",
        class: "",
      },

      {
        path: mappingRoutes.referential.categoriesPlaintes.listing,
        name: "Catégories de plainte ",
        class: "",
      },
      {
        path: mappingRoutes.referential.sensibilityPlaintes.listing,
        name: "Sensibilités de plainte",
        class: "",
      },
      {
        path: mappingRoutes.referential.universitiStructure.listing,
        name: "Structures universitaire",
        class: "",
      },

      {
        path: mappingRoutes.referential.faculties.list,
        name: "Facultés",
        class: "",
      },
    ],
  },

  {
    path: "#",
    prefix: "FAQS",
    title: "FAQS",
    name: "Forums ",
    icon: "question-circle",
    class: "",
    children: [
      {
        path: mappingRoutes.categorieFasq.listing,
        name: "Catégories",
        class: "",
      },
      {
        path: mappingRoutes.questionFaq.listing,
        name: "Questions",
        class: "",
      },
    ],
  },
];
